import '@fontsource/lato/400.css';
import '@fontsource/lato/700.css';
import '@fontsource/open-sans/400.css';
import '@fontsource/open-sans/600.css';
import '@fontsource/open-sans/700.css';
import '@fontsource/open-sans/800.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from '@/App';
import { AuthProvider } from '@/contexts/AuthContext';
import { CartProvider } from '@/contexts/CartContext';
import { ConnectivityProvider } from '@/contexts/ConnectivityContext';
import { ToastProvider } from '@/contexts/ToastContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import '@/styles/global.css';

const PRELOAD_RELOAD_KEY = 'carrfields-preload-reload';

window.addEventListener('vite:preloadError', (event) => {
  const currentUrl = window.location.href;
  if (sessionStorage.getItem(PRELOAD_RELOAD_KEY) === currentUrl) return;

  event.preventDefault();
  sessionStorage.setItem(PRELOAD_RELOAD_KEY, currentUrl);
  window.location.reload();
});

window.addEventListener('load', () => {
  sessionStorage.removeItem(PRELOAD_RELOAD_KEY);
}, { once: true });

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (attempt, error) => navigator.onLine && attempt < 2 && !(error instanceof Error && /40[134]/.test(error.message)),
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <ToastProvider>
            <ConnectivityProvider>
              <CartProvider>
                <AuthProvider>
                  <App />
                </AuthProvider>
              </CartProvider>
            </ConnectivityProvider>
          </ToastProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>,
);
